import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import BookExperience from "@/pages/BookExperience";
import AdminConfig from "@/pages/AdminConfig";
import AdminOverview from "@/pages/AdminOverview";
import AdminReaders from "@/pages/AdminReaders";
import AdminCrm from "@/pages/AdminCrm";
import AdminJourney from "@/pages/AdminJourney";
import AdminEditor from "@/pages/AdminEditor";
import AdminOfferings from "@/pages/AdminOfferings";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Offers from "@/pages/Offers";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Reflect from "@/pages/Reflect";
import AdminReflections from "@/pages/AdminReflections";
import Offerings from "@/pages/Offerings";
import OfferingDetail from "@/pages/OfferingDetail";
import Checkout from "@/pages/Checkout";
import VaultGallery from "@/pages/VaultGallery";
import GalleryPreview from "@/pages/GalleryPreview";
import AdminApplications from "@/pages/AdminApplications";
import AdminOrientation from "@/pages/AdminOrientation";
import AdminVault from "@/pages/AdminVault";
import AdminCodes from "@/pages/AdminCodes";
import Vault from "@/pages/Vault";
import AdminPreview from "@/pages/AdminPreview";
import AdminMedia from "@/pages/AdminMedia";
import AdminCampaigns from "@/pages/AdminCampaigns";
import AdminAccessEmails from "@/pages/AdminAccessEmails";
import AdminMessaging from "@/pages/AdminMessaging";
import AdminImmersionReviews from "@/pages/AdminImmersionReviews";
import AdminSendLog from "@/pages/AdminSendLog";
import AdminPlanner from "@/pages/AdminPlanner";
import AdminTelegram from "@/pages/AdminTelegram";
import AdminBookReview from "@/pages/AdminBookReview";
import AdminPlainWords from "@/pages/AdminPlainWords";
import AdminBookExtras from "@/pages/AdminBookExtras";
import Telegram from "@/pages/Telegram";
import SomaticReset from "@/pages/SomaticReset";
import RequireAdmin from "@/components/RequireAdmin";
import { AmbientMusic } from "@/components/AmbientMusic";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BookExperience />} />
          <Route path="/admin" element={<RequireAdmin><AdminOverview /></RequireAdmin>} />
          <Route path="/admin/config" element={<RequireAdmin><AdminConfig /></RequireAdmin>} />
          <Route path="/admin/readers" element={<RequireAdmin><AdminReaders /></RequireAdmin>} />
          <Route path="/admin/crm" element={<RequireAdmin><AdminCrm /></RequireAdmin>} />
          <Route path="/admin/journey" element={<RequireAdmin><AdminJourney /></RequireAdmin>} />
          <Route path="/admin/editor" element={<RequireAdmin><AdminEditor /></RequireAdmin>} />
          <Route path="/admin/offerings" element={<RequireAdmin><AdminOfferings /></RequireAdmin>} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/get-the-book" element={<Offers />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/reflect" element={<Reflect />} />
          <Route path="/admin/reflections" element={<RequireAdmin><AdminReflections /></RequireAdmin>} />
          <Route path="/admin/applications" element={<RequireAdmin><AdminApplications /></RequireAdmin>} />
          <Route path="/admin/orientation" element={<RequireAdmin><AdminOrientation /></RequireAdmin>} />
          <Route path="/admin/vault" element={<RequireAdmin><AdminVault /></RequireAdmin>} />
          <Route path="/admin/codes" element={<RequireAdmin><AdminCodes /></RequireAdmin>} />
          <Route path="/admin/preview" element={<RequireAdmin><AdminPreview /></RequireAdmin>} />
          <Route path="/admin/media" element={<RequireAdmin><AdminMedia /></RequireAdmin>} />
          <Route path="/admin/campaigns" element={<RequireAdmin><AdminCampaigns /></RequireAdmin>} />
          <Route path="/admin/access-emails" element={<RequireAdmin><AdminAccessEmails /></RequireAdmin>} />
          <Route path="/admin/messaging" element={<RequireAdmin><AdminMessaging /></RequireAdmin>} />
          <Route path="/admin/immersion-reviews" element={<RequireAdmin><AdminImmersionReviews /></RequireAdmin>} />
          <Route path="/admin/send-log" element={<RequireAdmin><AdminSendLog /></RequireAdmin>} />
          <Route path="/admin/planner" element={<RequireAdmin><AdminPlanner /></RequireAdmin>} />
          <Route path="/admin/telegram" element={<RequireAdmin><AdminTelegram /></RequireAdmin>} />
          <Route path="/admin/book-review" element={<RequireAdmin><AdminBookReview /></RequireAdmin>} />
          <Route path="/admin/plain-words" element={<RequireAdmin><AdminPlainWords /></RequireAdmin>} />
          <Route path="/admin/book-extras" element={<RequireAdmin><AdminBookExtras /></RequireAdmin>} />
          <Route path="/telegram" element={<Telegram />} />
          <Route path="/somatic-reset" element={<SomaticReset />} />
          <Route path="/vault" element={<Vault />} />
          <Route path="/offerings" element={<Offerings />} />
          <Route path="/offerings/:slug" element={<OfferingDetail />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/gallery" element={<Navigate to="/vault/gallery" replace />} />
          <Route path="/gallery/preview" element={<GalleryPreview />} />
          <Route path="/vault/gallery" element={<VaultGallery />} />
        </Routes>
        <AmbientMusic />
      </BrowserRouter>
    </div>
  );
}

export default App;
